import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from '../hooks/useInView';

// Tech-stack tags are proper nouns and stay the same across languages, so they
// live here rather than in the translation files, keyed by position.
const STACKS = [
  ['.NET', 'C#', 'Microservices', 'Kafka', 'Docker'],
  ['.NET', 'C#', 'Angular', 'SQL Server', 'Redis', 'Microservices'],
];

export default function Experience() {
  const [ref, inView] = useInView();
  const { t } = useTranslation();
  const items = t('experience.items', { returnObjects: true });

  return (
    <section id="experience" className={`section experience${inView ? ' in-view' : ''}`} ref={ref}>
      <div className="section__container">
        <h2 className="section__title">{t('experience.title')}</h2>
        <div className="timeline">
          {items.map((exp, i) => (
            <div key={i} className="timeline__item">
              <div className="timeline__marker" />
              <div className="timeline__card">
                <div className="exp__header">
                  <div className="exp__info">
                    <h3 className="exp__role">{exp.role}</h3>
                    <span className="exp__company">{exp.company}</span>
                  </div>
                  <div className="exp__meta">
                    <span className="exp__period">{exp.period}</span>
                    <span className="exp__location">{exp.location}</span>
                  </div>
                </div>
                <p className="exp__context">{exp.context}</p>
                <ul className="exp__achievements">
                  {exp.achievements.map((a, j) => (
                    <li key={j}>{a}</li>
                  ))}
                </ul>
                <div className="exp__stack">
                  {STACKS[i].map(tech => (
                    <span key={tech} className="tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
